import { deleteFile } from './deleteFileThunk';
export default deleteFile;
